import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { Field, reduxForm } from 'redux-form'
import { localize } from 'helpers/translator'

import { MainButton } from 'components/button'
import { Tooltip } from 'components/tooltip'

import TextInputForm from 'components/input/text/text_input_form'
import CheckboxInputForm from 'components/input/checkbox/checkbox_input_form'

import styles from './share_email.scss'

class ShareEmail extends PureComponent {

	constructor(props) {
		super(props)
		this.onFormSubmit = this.onFormSubmit.bind(this)
		this.onSelectGmail = this.onSelect.bind(this, 'Gmail')
		this.onSelectYahoo = this.onSelect.bind(this, 'Yahoo')
		this.onSelectOutlook = this.onSelect.bind(this, 'Outlook')
		this.onSelectNative = this.onSelect.bind(this, 'Native')
	}

	componentWillMount() {
		if (this.props.checkboxData) {
			this.props.initialize({
				checkbox: this.props.checkboxData.default,
			})
		}
	}

	onFormSubmit(values) {
		this.props.onFormSubmit(values).then(() => {
			this.props.reset('shareEmail')
		})
	}

	onSelect(source) {
		this.props.onSelect(source)
	}

	render() {
		const {handleSubmit} = this.props

		return (
			<form id="shareEmail" className={styles.form} onSubmit={handleSubmit(this.onFormSubmit)}>
				<div className={styles.mail_area}>
					<label className={styles.mail_area_label}>
						{localize('global_to')}
					</label>
					<div className={styles.mail_area_input}>
						<Field
							name="email"
							component={TextInputForm}
							type="text"
							props={{
								placeholder: localize('share_email_area_input_placeholder'),
							}}
						/>
					</div>
				</div>
				{this.props.checkboxData &&
				<div className={styles['editable-copy']}>
					<label className={styles['editable-copy-label']}>
						{this.props.checkboxData.text}
					</label>
					<div className={styles['editable-copy-checkbox']}>
						<Field
							name="checkbox"
							component={CheckboxInputForm}
							type="checkbox"
							props={{
								styleName: 'cta_checkbox',
							}}

						/>
						<div className={styles['editable-copy-checkbox-tooltip']}>
							<Tooltip arrow='top-center'>
								{localize('share_email_checkbox_tooltip')}
							</Tooltip>
						</div>
					</div>
				</div>}
				<div className={styles.share_area}>
					<span className={styles.share_area_title}>
						{localize('share_email_share_title')}
					</span>
					<div className={styles.share_area_options}>
						<a href={this.props.getExternalLink('gmail')}
							className={styles.share_area_options_gmail}
							target='_blank'
							rel='noopener noreferrer'
							onClick={this.onSelectGmail}>
							<svg height="40" width="40" viewBox="0 0 40 40"><path className={styles.svgpath} d="M20 1.673c10.105 0 18.328 8.222 18.328 18.327S30.105 38.328 20 38.328C9.893 38.328 1.67 30.105 1.67 20S9.894 1.673 20 1.673M20 0C8.953 0 0 8.953 0 20s8.953 20 20 20c11.043 0 20-8.953 20-20S31.043 0 20 0" fill="#6A686A"/><path className={styles.svgpath} d="M17.038 30.078c.89.225 1.847.34 2.84.34.893 0 1.744-.115 2.53-.342 2.455-.71 4.04-2.502 4.04-4.576 0-1.988-.642-3.18-2.37-4.395-.74-.52-1.412-1.283-1.424-1.517 0-.427.04-.63 1.004-1.378 1.244-.972 1.934-2.246 1.934-3.594 0-1.222-.377-2.307-1.018-3.07h.496c.104 0 .203-.03.287-.092l1.383-.994c.172-.124.242-.343.18-.542-.066-.2-.254-.336-.465-.336h-6.188c-.677 0-1.366.12-2.042.35-2.256.773-3.832 2.685-3.832 4.646 0 2.777 2.166 4.884 5.06 4.95-.056.22-.083.438-.083.65 0 .428.11.833.334 1.226h-.08c-2.76 0-5.25 1.346-6.195 3.35-.25.52-.37 1.047-.37 1.566 0 .508.12.992.38 1.45.59 1.056 1.87 1.875 3.59 2.308m.55-15.576c-.14-1.018.08-1.933.59-2.51.32-.374.76-.57 1.24-.57h.05c1.36.04 2.67 1.555 2.91 3.378.14 1.02-.09 1.98-.608 2.563-.33.375-.753.572-1.26.572h-.02c-1.34-.038-2.675-1.61-2.916-3.433m2.63 8.443h.055c.46.004.906.074 1.33.2.14.1.28.194.416.284.98.66 1.62 1.09 1.8 1.79.05.18.07.35.07.52 0 1.8-1.35 2.71-4.02 2.71-2.02 0-3.607-1.23-3.607-2.81-.004-1.45 1.85-2.72 3.954-2.72" fill="#6A686A"/></svg>
						</a>
						<a href={this.props.getExternalLink('yahoo')}
							className={styles.share_area_options_yahoo}
							target='_blank'
							rel='noopener noreferrer'
							onClick={this.onSelectYahoo}>
							<svg height="40" width="40" viewBox="0 0 40 40"><path className={styles.svgpath} d="M20 1.673c10.105 0 18.328 8.222 18.328 18.327S30.105 38.328 20 38.328C9.893 38.328 1.67 30.105 1.67 20S9.894 1.673 20 1.673M20 0C8.953 0 0 8.953 0 20s8.953 20 20 20c11.043 0 20-8.953 20-20S31.043 0 20 0" fill="#6A686A"/><g fill="#6A686A"><path className={styles.svgpath} d="M17.38 21.81c.077.573.145 3.96-.077 4.22-.45.512-2.5.377-3 .414l-.17 1.05c.905.026 3.848-.08 4.762-.08 1.803 0 4.96-.007 5.41.028l.055-1.102c-.457-.082-2.943-.012-3.29-.094-.07-.535-.157-4.102-.08-4.47.342-1.066 5.57-5.406 6.14-5.572.128-.025.32-.073.538-.123h1.684l.262-.41h.02l.652-1.01h-.03l.065-.11H21.2l.352 1.54h2.492l-4.19 4.07c-.856-1.27-2.86-3.91-4.26-6.1h3.138v-1.18l.035-.26h-.035v-.11h-10.4v1.55h3.085c1.197 1.007 5.773 7.156 5.962 7.767"/><path className={styles.svgpath} d="M28.605 17.668l.035 6.97 1.398.12 1.63-6.76c-.273-.01-2.742-.263-3.063-.33M29.88 27.5l.225-1.617-.808-.043-.9-.12.01 1.653.71.065"/></g></svg>
						</a>
						<a href={this.props.getExternalLink('outlook')}
							className={styles.share_area_options_outlook}
							target='_blank'
							rel='noopener noreferrer'
							onClick={this.onSelectOutlook}>
							<svg height="40" width="40" viewBox="0 0 40 40"><path className={styles.svgpath} d="M20 1.673c10.105 0 18.328 8.222 18.328 18.327S30.105 38.328 20 38.328C9.893 38.328 1.67 30.105 1.67 20S9.894 1.673 20 1.673M20 0C8.953 0 0 8.953 0 20s8.953 20 20 20c11.043 0 20-8.953 20-20S31.043 0 20 0" fill="#6A686A"/><g fill="#6A686A"><path className={styles.svgpath} d="M23.023 13.004v4.75l1.66 1.048c.043.013.137.014.184 0l7.145-4.82c0-.572-.535-.978-.832-.978h-8.157z"/><path className={styles.svgpath} d="M23.023 19.53l1.512 1.042c.215.157.473 0 .473 0-.258.157 7.004-4.668 7.004-4.668v8.736c0 .953-.61 1.352-1.293 1.352h-7.7V19.53zm-7.848-2.193c-.517 0-.928.246-1.23.73-.304.48-.456 1.125-.456 1.924 0 .81.15 1.46.45 1.93.3.47.7.71 1.19.71.51 0 .91-.23 1.21-.68.29-.46.44-1.09.44-1.91 0-.84-.15-1.5-.44-1.98-.29-.47-.68-.7-1.19-.7"/><path className={styles.svgpath} d="M7.988 10.587v18.6l14.14 2.964V7.85L7.99 10.587zm9.46 12.444c-.597.79-1.374 1.18-2.335 1.18-.938 0-1.7-.38-2.29-1.14-.59-.76-.887-1.75-.887-2.98 0-1.29.3-2.34.9-3.14.6-.8 1.393-1.19 2.38-1.19.934 0 1.69.38 2.266 1.15.578.77.863 1.77.863 3.03.002 1.29-.297 2.33-.896 3.11"/></g></svg>
						</a>
						<a href={this.props.getExternalLink('client')}
							className={styles.share_area_options_hotmail}
							target='_self'
							onClick={this.onSelectNative}>
							<svg height="40" width="40" viewBox="0 0 40 40"><path className={styles.svgpath} d="M20 1.673c10.105 0 18.328 8.222 18.328 18.327S30.105 38.328 20 38.328C9.893 38.328 1.67 30.105 1.67 20S9.894 1.673 20 1.673M20 0C8.953 0 0 8.953 0 20s8.953 20 20 20c11.043 0 20-8.953 20-20S31.043 0 20 0" fill="#6A686A"/><g fill="#6A686A"><path className={styles.svgpath} d="M17.5 15.833h5v5h-5z"/><path className={styles.svgpath} d="M30.145 16.188c-.04-.03-.07-.042-.105-.057V10.3c0-.17-.137-.31-.3-.31h-7.45c-.02-.02-.035-.04-.063-.064l-1.844-1.46c-.21-.17-.56-.17-.77 0L17.77 9.92c-.03.022-.043.043-.063.064h-7.435c-.164 0-.3.14-.3.31v5.83c-.038.013-.076.03-.118.063l-1.137.9c-.21.167-.386.53-.386.804v13.28c0 .28.22.51.49.51h22.36c.27 0 .49-.22.49-.5V17.9c0-.275-.17-.637-.38-.804l-1.13-.9zm-1.71 3.687c0 .17-.118.374-.263.455L20.27 24.7c-.145.08-.383.08-.527 0l-7.9-4.37c-.145-.08-.264-.284-.264-.455V11.62c0-.17.13-.31.29-.31h16.26c.16 0 .3.14.3.31v8.255h-.01z"/><path className={styles.svgpath} d="M15.833 21.25h8.333v.832h-8.333zm0 1.666h8.333v.834h-8.333zm2.5-6.666h3.333v.833h-3.333z"/></g></svg>
						</a>
					</div>
				</div>
				<div className={styles.content_send}>
					<MainButton type='submit' >
						{localize('global_send')}
					</MainButton>
				</div>
				{this.props.emailHint !== '' &&
				<div className={styles['hint-text']}>
					{this.props.emailHint}
				</div>}
			</form>
		)
	}
}

ShareEmail.defaultProps = {
	onSelect: () => {},
}

ShareEmail.propTypes = {
	handleSubmit: PropTypes.func,
	submitting: PropTypes.bool,
	onFormSubmit: PropTypes.func,
	onSelect: PropTypes.func,
}

const shareEmailForm = reduxForm({
	form: 'ShareEmail',
	fields: ['email', 'checkbox'],
})(ShareEmail)

export default shareEmailForm
